export const BLOG_PAGINATION = {
  limit: 8,
};
